<template>
    <!-- <a-card> -->
    <div style="text-align: center">
        <el-button v-print="'##printTest'" class="btn-style btn-print" type="primary">打印销售单</el-button>
        <el-button v-print="printViewInfo" class="btn-style btn-print" type="primary">打印制作单</el-button>

        <div
            class="tables"
            id="printTest"
            style="width: 100%; margin: 0 auto; padding: 10px; display: flex; align-items: center; color: #000"
        >
            <div id="pdfDom" style="text-align: center; font-size: 14px">
                <p align="center" class="title">{{ orderInfo.userName }}销售单</p>
                <div style="width: 100%; margin-bottom: 10px">
                    <div style="width: 35%; float: left; font-weight: bold">客户名称: {{ orderInfo.customerName }}</div>
                    <div style="width: 35%; float: left; font-weight: bold">
                        联系人/电话: {{ orderInfo.contacts }}{{ orderInfo.telephone }}
                    </div>
                    <!-- <div style="width: 30%;float: right;font-weight:bold">下单时间:{{ orderInfo. orderTime}} </div> -->
                    <div style="width: 30%; float: right; font-weight: bold">
                        收款日期:
                        {{ (orderInfo.orderTime || "").split(" ")[0] }}
                    </div>
                </div>
                <div style="width: 100%; margin-bottom: 10px">
                    <div style="width: 50%; float: left; font-weight: bold">联系地址: {{ orderInfo.address }}</div>
                    <div style="width: 50%; float: left; font-weight: bold">备注: {{ orderInfo.remarks }}</div>
                    <!-- <div style="width: 30%;float: right;font-weight:bold">收款日期:{{ (Receipt.payTime || '').split(' ')[0] }}</div> -->
                </div>
                <table class="table" id="printpdf" style="width: 100%" cellpadding="2" cellspacing="0" border="1" bordercolor="#000000">
                    <tr>
                        <td colspan="1" width="80">NO.</td>
                        <td colspan="4" width="400">产品名称</td>
                        <td colspan="2" width="200">产品类别</td>
                        <td colspan="2" width="80">规格</td>
                        <td colspan="2" width="80">单价</td>
                        <td colspan="2" width="80">数量</td>
                        <td colspan="2" width="80">总价</td>
                        <td colspan="4" width="300">备注</td>
                    </tr>
                    <tr v-for="(item, index) in orderDate" :key="index">
                        <td colspan="1" width="80">{{ index + 1 }}</td>
                        <td colspan="4" width="400">{{ item.category }}</td>
                        <td colspan="2" width="200">{{ item.subclass }}</td>
                        <td colspan="2" width="80">{{ item.specifications }}</td>
                        <td colspan="2" width="80">{{ item.totalPrice }}</td>
                        <td colspan="2" width="80">{{ item.number }}</td>
                        <td colspan="2" width="80">{{ item.price }}</td>
                        <td colspan="4" width="300">{{ item.remarks }}</td>
                    </tr>
                    <tr>
                        <td colspan="4">总计: {{ orderInfo.orderAmount }}</td>
                        <!-- <td colspan="6" width="220"></td>
                        <td colspan="2" width="220"></td>
                        <td colspan="4" width="220"></td> -->
                        <td colspan="4">已收款： {{ orderInfo.paid }}</td>

                        <td colspan="4">优惠： {{ orderInfo.preferentialAmount }}</td>
                        <td colspan="4">欠款： {{ orderInfo.unpaid }}</td>
                    </tr>
                </table>
                <div style="width: 100%; margin-bottom: 10px">
                    <div style="width: 25%; float: left; font-weight: bold">开单人: {{ orderInfo.operator }}</div>
                    <div style="width: 25%; float: left; font-weight: bold">交货方式: {{ orderInfo.deliveryMethod }}</div>
                    <div style="width: 25%; float: left; font-weight: bold">
                        发货时间:
                        {{ (orderInfo.deliveryTime || "").split(" ")[0] }}
                    </div>
                    <div style="width: 25%; float: left; font-weight: bold">客户签字:</div>
                </div>
                <p align="center">专业加工:写真 喷绘雕刻 条幅 欢迎洽谈合作!</p>
            </div>
        </div>

        <p align="center" class="title" style="margin-top: 50px">工艺制作单</p>
        <div id="mack_order">
            <div class="tableInfo">
                <div class="x_flex table-info">
                    <p>
                        <span class="table-label">客户名称：</span>
                        <span class="table-value">{{ tableRowInfo.customerName ? tableRowInfo.customerName : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">订单名称：</span>
                        <span class="table-value">{{ tableRowInfo.orderName ? tableRowInfo.orderName : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">操作员：</span>
                        <span class="table-value">{{ tableRowInfo.operator ? tableRowInfo.operator : "--" }}</span>
                    </p>
                </div>
                <div class="x_flex table-info">
                    <p>
                        <span class="table-label">发货方式：</span>
                        <span class="table-value">{{ tableRowInfo.deliveryMethod ? tableRowInfo.deliveryMethod : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">计件数量：</span>
                        <span class="table-value">{{ tableRowInfo.area ? tableRowInfo.area : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">发货时间：</span>
                        <span class="table-value">{{ (orderInfo.deliveryTime || "").split(" ")[0] }}</span>
                    </p>
                </div>
                <div class="x_flex table-info">
                    <!--  <p>
                        <span class="table-label">联系地址：</span>
                        <span class="table-value">{{ orderInfo.address }}</span>
                    </p> -->
                    <p>
                        <span class="table-label">联系信息：</span>
                        <span class="table-value">
                            {{ orderInfo.contacts }}{{ orderInfo.telephone }}<br />
                            {{ orderInfo.address }}
                        </span>
                    </p>
                    <p>
                        <span class="table-label" style="font-size: 24px; font-weight: bold; color: #000">面板</span>
                    </p>
                </div>
                <el-image class="print-image" :src="orderInfo.dimensionalBarcode" style="width: 100px; height: 100px">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div> </el-image
                ><br />

                <el-image class="print-image" :src="orderInfo.thumbnailPath">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
            <div class="tableInfo" style="display: none">
                <div class="x_flex table-info">
                    <p>
                        <span class="table-label">客户名称：</span>
                        <span class="table-value">{{ tableRowInfo.customerName ? tableRowInfo.customerName : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">订单名称：</span>
                        <span class="table-value">{{ tableRowInfo.orderName ? tableRowInfo.orderName : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">操作员：</span>
                        <span class="table-value">{{ tableRowInfo.operator ? tableRowInfo.operator : "--" }}</span>
                    </p>
                </div>
                <div class="x_flex table-info">
                    <p>
                        <span class="table-label">发货方式：</span>
                        <span class="table-value">{{ tableRowInfo.deliveryMethod ? tableRowInfo.deliveryMethod : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">计件数量：</span>
                        <span class="table-value">{{ tableRowInfo.area ? tableRowInfo.area : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">发货时间：</span>
                        <span class="table-value">{{ (orderInfo.deliveryTime || "").split(" ")[0] }}</span>
                    </p>
                </div>
                <div class="x_flex table-info">
                    <p>
                        <span class="table-label">联系信息：</span>
                        <span class="table-value"> {{ orderInfo.contacts }}{{ orderInfo.telephone }}<br />{{ orderInfo.address }} </span>
                    </p>
                    <p>
                        <span class="table-label" style="font-size: 24px; font-weight: bold; color: red">底板</span>
                    </p>
                </div>
                <el-image class="print-image" :src="orderInfo.dimensionalBarcode" style="width: 100px; height: 100px">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div> </el-image
                ><br />

                <el-image class="print-image" :src="orderInfo.thumbnailPath">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
            <div class="tableInfo" style="display: none">
                <div class="x_flex table-info">
                    <p>
                        <span class="table-label">客户名称：</span>
                        <span class="table-value">{{ tableRowInfo.customerName ? tableRowInfo.customerName : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">订单名称：</span>
                        <span class="table-value">{{ tableRowInfo.orderName ? tableRowInfo.orderName : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">操作员：</span>
                        <span class="table-value">{{ tableRowInfo.operator ? tableRowInfo.operator : "--" }}</span>
                    </p>
                </div>
                <div class="x_flex table-info">
                    <p>
                        <span class="table-label">发货方式：</span>
                        <span class="table-value">{{ tableRowInfo.deliveryMethod ? tableRowInfo.deliveryMethod : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">计件数量：</span>
                        <span class="table-value">{{ tableRowInfo.area ? tableRowInfo.area : "--" }}</span>
                    </p>
                    <p>
                        <span class="table-label">发货时间：</span>
                        <span class="table-value">{{ (orderInfo.deliveryTime || "").split(" ")[0] }}</span>
                    </p>
                </div>
                <div class="x_flex table-info">
                    <p>
                        <span class="table-label">联系信息：</span>
                        <span class="table-value">
                            <span>{{ orderInfo.contacts }}{{ orderInfo.telephone }} <br />{{ orderInfo.address }}</span>
                        </span>
                    </p>
                    <p>
                        <span class="table-label" style="font-size: 24px; font-weight: bold; color: green">出货</span>
                    </p>
                </div>
                <el-image class="print-image" :src="orderInfo.dimensionalBarcode" style="width: 100px; height: 100px">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div> </el-image
                ><br />

                <el-image class="print-image" :src="orderInfo.thumbnailPath">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
        </div>
    </div>
    <!-- </a-card> -->
</template>

<script>
export default {
    name: "BillPrint",
    data() {
        return {
            loading: false,
            orderDate: [],
            orderInfo: {
                userName: "", //公司名称
                customerName: "", //客户名称
                contacts: "", //联系人
                telephone: "", //联系电话
                orderTime: "", //下单时间
                address: "", //联系地址
                remarks: "", //备注
                orderAmount: "", //总价
                paid: "", //收款
                unpaid: "", //欠款
                area: "",
                preferentialAmount: "",
                operator: "", //开单人
                deliveryMethod: "", //交货方式
                deliveryTime: "", //交货时间
                thumbnailPath: "",
                dimensionalBarcode: "",
            },
            receiptData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                total: 0,
            },
            pages: {
                size: 10,
                current: 1,
            },
            billNo: 0,
            tableRowInfo: {},
            printViewInfo: {
                id: "mack_order", //打印区域的唯一的id属性
                popTitle: "制作单", // 页眉文字 （不设置时显示undifined）（页眉页脚可以在打印页面的更多设置的选项中取消勾选）
                extraHead: "", // 最左上方的头部文字，附加在head标签上的额外标签，使用逗号分割
                preview: false, // 是否启动预览模式，默认是false （开启预览模式ture会占满整个屏幕，不建议开启，除非业务需要）
                previewTitle: "预览的标题", // 打印预览的标题(预览模式preview为true时才显示)
                previewPrintBtnLabel: "预览结束，开始打印", // 打印预览的标题下方的按钮文本，点击可进入打印(预览模式preview为true时才显示)
                zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
                previewBeforeOpenCallback(that) {
                    console.log("正在加载预览窗口！");
                    console.log(that.msg, this);
                }, // 预览窗口打开之前的callback (预览模式preview为true时才执行) （that可以取到data里的变量值）
                previewOpenCallback() {
                    console.log("已经加载完预览窗口，预览打开了！");
                }, // 预览窗口打开时的callback (预览模式preview为true时才执行)
                beforeOpenCallback() {
                    console.log("开始打印之前！");
                }, // 开始打印之前的callback
                openCallback() {
                    console.log("执行打印了！");
                }, // 调用打印时的callback
                closeCallback() {
                    console.log("关闭了打印工具！");
                }, // 关闭打印的callback(无法区分确认or取消)
                clickMounted() {
                    console.log("点击v-print绑定的按钮了！");
                },
                // url: 'http://localhost:8080/', // 打印指定的URL，确保同源策略相同
                // asyncUrl (reslove) {
                //   setTimeout(() => {
                //     reslove('http://localhost:8080/')
                //   }, 2000)
                // },
                standard: "",
                extarCss: "",
            },
        };
    },
    created() {
        if (this.$route.query.orderDate) {
            this.orderDate = this.$route.query.orderDate;
            console.log(this.orderDate);
        }
        if (this.$route.query.orderInfo) {
            this.orderInfo = this.$route.query.orderInfo;
        }
        this.tableRowInfo = this.$route.query.tableRow ? this.$route.query.tableRow : {};
    },
    methods: {
        init() {
            this.loading = true;
            this.billNo = this.$route.query.billNo;
            console.log("billNo", this.billNo);
            // getReceipt(this.billNo).then(res => {
            //   this.receiptData = res.data
            //   this.receiptData.forEach(da => {
            //     da.price = da.price / 100.0
            //     da.amount = da.amount / 100.0
            //     da.buildArea = da.buildArea / 100.0
            //     da.endRecord = da.endRecord / 100.0
            //     da.startRecord = da.startRecord / 100.0
            //     da.discountAmount = da.discountAmount / 100.0
            //     da.actualAmount = da.actualAmount / 100.0
            //     da.record = da.endRecord - da.startRecord
            //   })
            //   this.Receipt = res.data[0]
            //   this.Receipt.totalAmount = this.Receipt.totalAmount / 100.0
            //   this.Receipt.totalActualAmount = this.Receipt.totalActualAmount / 100.0
            // })
            console.log("data", this.num);
        },
        receipt(id) {
            this.loading = true;
            // receiptPdf(id).then(res => {
            //   console.log(res)
            //   const blob = new Blob([res], { type: 'application/pdf' })
            //   const url = URL.createObjectURL(blob)
            //   printJS({
            //     printable: url,
            //     type: 'pdf'
            //   })
            // }).catch(err => {
            //   this.$message.error(err.msg)
            // })
        },
    },
};
</script>

<style scoped>
.table p {
    text-align: center;
    margin: 10px 0;
    color: #000c17;
    font-size: 18px;
}

.table {
    border-style: solid;
    border-width: 1pt;
    font-variant: normal;
}

td {
    border-style: solid;
    border-width: 1pt;
}

.centent > p {
    float: left;
    font-size: 18px;
    font-variant: normal;
    color: #000c17;
}

.tables {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#pdfDom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.title {
    font-size: 30px;
    font-variant: normal;
    color: var(--color);
}

.table-info {
    width: 100%;
    justify-content: space-between;
    margin: 30px auto;
}
.table-info > p {
    min-width: 200px;
    padding-right: 20px;
    display: flex;
    /* overflow: hidden; */
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
}
.table-label {
    color: var(--secondColor);
}
.table-value {
    color: var(--color);
    text-align: left;
}
.pay {
    color: var(--theme-color);
}
.no-pay {
    color: #ff4d4d;
}
.tableInfo {
    margin-bottom: 50px;
    page-break-after: always;
}
.print-image {
    width: 100%;
    height: 410px;
    text-align: center;
    margin-bottom: 30px;
}
::v-deep.print-image img {
    /* max-width: 100%;
    max-height: 100%; */
    object-fit: contain;
}
::v-deep.print-image .image-slot {
    font-size: 50px;
}
.btn-style {
    min-width: 72px;
    border-radius: 8px;
}
.btn-search {
    background: var(--theme-color);
}
.btn-buy {
    background: #ff8429;
}
.btn-print {
    background: #4093ff;
}
</style>
<style>
@media print {
    .hidden {
        display: none;
    }
    @page {
        size: auto;
    }
    body,
    html {
        height: auto !important;
    }
    .tableInfo {
        display: block !important;
    }
}
</style>
